<div class="landing-container">
	<div class="mobile-logo-banner">
		<img src="/assets/logo-blanc.png" alt="Blackrock Games" />
	</div>
	<div class="nav-row">
		<div class="logo-landing"></div>
		<a href="https://espacepro.blackrockgames.fr" class="nav-link no-underline pb-2">
			<div class="text-center text-white mb-2">Espace Pro</div>
			<img src="/assets/logo_espacepro.png" />
		</a>
		<a href="https://site-export.blackrockgames.fr" class="nav-link no-underline pb-2">
			<div class="text-center text-white mb-2">Export</div>
			<img src="/assets/logo_export.png" />
		</a>
		<a href="https://blackrockgames.fr/home/" class="nav-link no-underline pb-2">
			<div class="text-center text-white mb-2">Grand Public</div>
			<img src="/assets/logo_gp.png" />
		</a>
	</div>
	<div class="hero-section">
		<div class="text-1">DISTRIBUTEUR DE JEU DE SOCIÉTÉ</div>
		<a href="https://blackrockgames.fr/home" class="hero-link">
			<img src="/assets/photo_landing.jpg" class="photo-landing"/>
			<div class="hero-overlay">
				<div class="text-2">ENVIE DE JOUER ?</div>
				<div class="text-3">Découvrez nos jeux</div>
			</div>
		</a>
	</div>
</div>